import React, { Fragment } from "react";
import { Backdrop, CircularProgress, LinearProgress } from "@mui/material";
import { Box } from "@mui/system";
import PropTypes from "prop-types";

const Loading = ({
	type ='linear',
	color = "secondary",
	variant = "indeterminate",
	value = 100,
}) => {
	return (
		<Fragment>
			{type === "circular" && (
				<Box sx={{ width: "100%" }} display="flex" justifyContent="center">
					<CircularProgress color={color} variant={variant} value={value} />
				</Box>
			)}

			{type === "linear" && (
				<Box sx={{ width: "100%" }}>
					<LinearProgress color={color} variant={variant} value={value} />
				</Box>
			)}

			{type === "backdrop" && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={true}
				>
					<CircularProgress color={color} variant={variant} value={value} />
				</Backdrop>
			)}
		</Fragment>
	);
};

Loading.propTypes = {
	/** Style of the loading  */
	type: PropTypes.oneOf(["circular", "linear", "backdrop"]),

	/** Color of the loading */
	color: PropTypes.oneOf([
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning",
		"inherit",
	]),
	/** Type of the loading */
	variant: PropTypes.oneOf(["determinate", "indeterminate", "buffer", "query"]),

	/** The value for the buffer variant 0 to 100 */
	value: PropTypes.number,
};

export default Loading;
